import {BrowserModule} from '@angular/platform-browser';
import {NgModule} from '@angular/core';
import {FormsModule} from '@angular/forms';
import {HttpModule} from '@angular/http';

import {AppComponent} from './app.component';
import {AppRoutingModule} from './app-routing.module';
import {ProjectModule} from './project/project.module';
import {LoginViewComponent} from './_shared/login-view/login-view.component';
import {AuthenticationService} from './_shared/services/authentication.service';
import {AuthGuard} from './_shared/guards/authentication-guard';
import {FolderModule} from './folder/folder.module';
import {MyAccountViewComponent} from './_shared/my-account-view/my-account-view.component';
import {UserService} from './_shared/services/user.service';
import {NotAuthGuard} from './_shared/guards/not-authentication-guard';
import {AdminGuard} from './_shared/guards/admin-guard';
import {SteelProfileModule} from './steel-profile/steel-profile.module';
import {NavModule} from './_shared/nav/nav.module';


@NgModule({
    declarations: [
        AppComponent,
        LoginViewComponent,
        MyAccountViewComponent
    ],
    imports: [
        BrowserModule,
        FormsModule,
        HttpModule,
        SteelProfileModule,
        ProjectModule,
        FolderModule,
        NavModule,
        AppRoutingModule
    ],
    providers: [
        AuthenticationService,
        AuthGuard,
        NotAuthGuard,
        UserService,
        AdminGuard
    ],
    bootstrap: [AppComponent]
})
export class AppModule {
}



// WEBPACK FOOTER //
// ./src/app/app.module.ts